import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { RouterOutlet } from '@angular/router';
import { DeclinedDialog } from '@features/disclaimer/declined-dialog/declined-dialog';
import { tap } from 'rxjs';
import { STORAGE_KEYS } from '@shared/constants';
import { DisclaimerService } from '@features/disclaimer';

@Component({
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `@if (showDisclaimer()) {
      <div class="blurry-mask"></div>
    }
    <router-outlet></router-outlet>`,
})
export class AppContainer implements OnInit {
  private readonly disclaimerService = inject(DisclaimerService);
  private readonly dialogService = inject(Dialog);
  showDisclaimer = signal(true);

  ngOnInit(): void {
    const disclaimerAccepted = sessionStorage.getItem(STORAGE_KEYS.DISCLAIMER_ACCEPTED);
    if (!disclaimerAccepted) {
      this.openDisclaimer();
    } else {
      this.showDisclaimer.set(false);
    }
  }

  private openDisclaimer(): void {
    this.disclaimerService
      .openDisclaimer()
      .closed.pipe(
        tap((accepted) => {
          if (!accepted) {
            const cancelRef = this.dialogService.open(DeclinedDialog, {
              ariaLabel: 'Access declined',
            });
            cancelRef.closed.subscribe(() => this.openDisclaimer());
          } else {
            this.showDisclaimer.set(false);
            sessionStorage.setItem(STORAGE_KEYS.DISCLAIMER_ACCEPTED, 'accepted');
          }
        }),
      )
      .subscribe();
  }
}
